import React from 'react';
import logo from '../assets/peticle-icon.png';

function Header() {
    return (
        <header className="absolute inset-x-0 top-0 z-10 w-full shadow">
            <div className="px-4 mx-auto sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16 lg:h-20">
                    <div className="flex-shrink-0">
                        <a href="/" title="Peticle" className="flex items-center gap-2">
                            <img className="rounded-2xl" src={logo} width={44} height={44} alt="Peticle logo" />
                            <span className="text-lg font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#4a7c59] to-[#4a7c59]">
                                Peticle
                            </span>
                        </a>
                    </div>

                    <div className="lg:flex lg:items-center lg:justify-center lg:space-x-10">
                        <a href="privacy-policy" title="Privacy Policy" className="text-decoration-none text-base text-transparent bg-clip-text bg-gradient-to-r from-[#4a7c59] to-[#4a7c59] transition-all duration-200 hover:opacity-80">
                            Privacy Policy
                        </a>
                        <a href="data-settings" title="Data Settings" className="text-decoration-none text-base text-transparent bg-clip-text bg-gradient-to-r from-[#4a7c59] to-[#4a7c59] transition-all duration-200 hover:opacity-80">
                            Data Settings
                        </a>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
